import { Component } from '@angular/core';
import { FGBSharedModule } from '@fgb/portal-component-library/src/lib/shared';

@Component({
  selector: 'fgbcl-locked-reward-status',
  standalone: true,
  imports: [FGBSharedModule],
  templateUrl: './locked-reward-status.component.html',
  styleUrl: './locked-reward-status.component.scss',
})
export class LockedRewardStatusComponent {}
